import "core-js/modules/es6.regexp.replace.js";
import "core-js/modules/es6.regexp.to-string.js";
/**
 * @description to capitalize value passed as parameter
 *
 * @param value value to capitalize
 * @param every boolean to set capital letter to every word
 */

var capitalize = _ref => {
  var {
    value,
    every = false
  } = _ref;
  if (!value || typeof value !== 'string') return '';
  var valueStr = value.toString().toLowerCase();
  if (every) return valueStr.replace(/\b\w/g, letter => letter.toUpperCase());
  return valueStr.charAt(0).toUpperCase() + valueStr.slice(1);
};
export default capitalize;